import { OperatingUnitBase } from './base/operating-unit-base';

export class OperatingUnit extends OperatingUnitBase { }